<template>
<big-round-button color="secondary" :height="height" :width="width" to="/addIssue" icon="mdi-email-outline" text="ΑΙΤΗΜΑ"></big-round-button>
</template>

<script>
import BigRoundButton from "@/components/BigRoundButton";
export default {
name: "IssueButton",
  props:{
    height: {type: String, default: '100'},
    width: {type: String, default: '100'},
  },
  components: {BigRoundButton}
}
</script>

<style scoped>

</style>
